"use client";

// import { useState, useEffect } from "react";
import { useCallback, useEffect, useState } from "react";
import styles from "./Carousel.module.css";
import classNames from "classnames/bind";
import { CarouselButton } from "../CarouselButton/CarouselButton";
// import { useVisibleCount } from "./useVisibleCount";
import { EmblaCarouselType, EmblaOptionsType } from "embla-carousel";
import useEmblaCarousel from "embla-carousel-react";
import { WheelGesturesPlugin } from "embla-carousel-wheel-gestures";

const cx = classNames.bind(styles);

export function Carousel({
  items,
  headline = "Our latest stories",
  description,
  showNav = true,
  // aspectRatio = "4:3",
  // trackClassName,
  seeAllLink,
  // isPressRelease = false,
  variant,
}: {
  items: React.ReactNode[];
  headline?: string;
  description?: string;
  showNav?: boolean;
  // aspectRatio?: "4:3" | "16:9";
  // trackClassName?: string;
  seeAllLink?: { url: string; label?: string };
  // isPressRelease?: boolean;
  variant?: string;
}) {
  // Embla Options
  const EMBLA_OPTIONS: EmblaOptionsType = {
    align: "start",
    containScroll: "trimSnaps",
    direction: "ltr",
    loop: false,
    watchDrag: true,
    dragFree: true,
  };

  // Embla Carousel
  const [emblaRef, emblaApi] = useEmblaCarousel(EMBLA_OPTIONS, [
    WheelGesturesPlugin({ forceWheelAxis: "x" }),
  ]);

  // Embla selected/scroll
  // const [selectedIndex, setSelectedIndex] = useState<number>(0);
  // const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);

  // Embla Next/Prev buttons
  const [prevBtnDisabled, setPrevBtnDisabled] = useState<boolean>(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState<boolean>(true);

  // Embla Prev button
  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
  }, [emblaApi]);

  // Embla Next button
  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
  }, [emblaApi]);

  // Embla onInit
  // const onInit = useCallback((emblaApi: EmblaCarouselType) => {
  //   setScrollSnaps(emblaApi.scrollSnapList());
  // }, []);

  // Embla onSelect
  const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
    // setSelectedIndex(emblaApi.selectedScrollSnap());
    setPrevBtnDisabled(!emblaApi.canScrollPrev());
    setNextBtnDisabled(!emblaApi.canScrollNext());
  }, []);

  // Embla useEffect
  useEffect(() => {
    if (!emblaApi) return;

    // onInit(emblaApi);
    onSelect(emblaApi);
    // emblaApi.on("reInit", onInit);
    emblaApi.on("reInit", onSelect);
    emblaApi.on("select", onSelect);
  }, [emblaApi, onSelect]);

  const canNav = showNav;

  return (
    <section className={cx("container")}>
      <div className={cx("inner")}>
        <div className={cx("carousel-header")} data-variant={variant}>
          <h2 className={cx("carousel-headline", "text-h1")}>{headline}</h2>
          {description ? (
            <p className={cx("carousel-desc")}>{description}</p>
          ) : seeAllLink && seeAllLink.url ? (
            <a
              href={seeAllLink.url}
              className={cx("see-all-link")}
              tabIndex={0}
            >
              {seeAllLink.label || "See all"}
            </a>
          ) : canNav ? (
            <div className={cx("carousel-nav")}>
              <CarouselButton
                kind="previous"
                onClick={onPrevButtonClick}
                disabled={prevBtnDisabled}
                className={cx("nav-btn", "nab-btn--prev")}
              />
              <CarouselButton
                kind="next"
                onClick={onNextButtonClick}
                disabled={nextBtnDisabled}
                className={cx("nav-btn", "nab-btn--next")}
              />
            </div>
          ) : null}
        </div>
        <div
          className={cx("embla")}
          data-count={items.length}
          data-variant={variant}
        >
          <div className={cx("embla-viewport")} ref={emblaRef}>
            <div className={cx("embla-container")}>
              {items.map((item, i) => (
                <div className={cx("embla-slide")} key={i}>
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Carousel;
